import React, { useState, useEffect } from 'react';
import formatTime from '../utils/formatTime';
import '../scss/Timer.scss';

function Timer2({ minutes }) {
  const [seconds, setSeconds] = useState(minutes);
  const [isRunning, setIsRunning] = useState(false);
  
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (isRunning && seconds > 0) {
        setSeconds(prevSeconds => prevSeconds - 1);
      } else if (isRunning && seconds === 0) {
        setIsRunning(false);
        clearInterval(intervalId);
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, [isRunning, seconds]);

  const startTimer = () => setIsRunning(true);
  
  const pauseTimer = () => setIsRunning(false);

  const resetTimer = () => {
    setIsRunning(false);
    setSeconds(minutes);
  };

  const timerAction = () => (
    isRunning 
      ? { action: pauseTimer, icon: 'pause' }
      : (seconds === 0)
        ? { action: resetTimer, icon: 'reset' }
        : { action: startTimer, icon: 'start' }
  );
  
  const { action, icon } = timerAction();

  return (
    <button className='iconLabel timer' onClick={action} data-off={!seconds}>
      <span className="icon" data-icon={icon}></span>
      <div>{formatTime(seconds)}</div>
    </button>
  );
}

export default Timer2;
